module.exports = __webpack_public_path__ + "f63e07633cdb75ec6e61771557c089dc.svg";